"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSingletonInstance = exports.getAxiosUserInstance = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module AxiosUserInstance */
var authTokenInstance;
/**
 * This method will return Axios Auth instnace with baseAPI configuration
 * It will return the module singleton to ensure the performance
 * To regenerate the singleton instance, use `clearSingletonInstance` method
 * @param {String} baseApi the base API for auth
 * @returns {AxiosInstance} the axios instance
 * @memberof AxiosUserInstance
 */

var getAxiosUserInstance = function getAxiosUserInstance(baseApi) {
  if (!authTokenInstance) {
    authTokenInstance = _axios.default.create({
      baseURL: baseApi
    });
    authTokenInstance.interceptors.response.use(function (response) {
      return response.data;
    }, null);
  }

  return authTokenInstance;
};
/**
 * This method is used to clear the module Axios singleton instance
 * It can be used for the purpose of testing or for the specific use case
 * @memberof AxiosUserInstance
 */


exports.getAxiosUserInstance = getAxiosUserInstance;

var clearSingletonInstance = function clearSingletonInstance() {
  authTokenInstance = null;
};

exports.clearSingletonInstance = clearSingletonInstance;